function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M0.5 16C0.5 7.16344 7.66344 0 16.5 0C25.3366 0 32.5 7.16344 32.5 16C32.5 24.8366 25.3366 32 16.5 32C7.66344 32 0.5 24.8366 0.5 16Z",
  fill: "#D13D9E"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M17 6C12.865 6 9.5 9.38833 9.5 13.5542C9.5 19.4733 16.295 25.585 16.5842 25.8417C16.7033 25.9475 16.8517 26 17 26C17.1483 26 17.2967 25.9475 17.4158 25.8425C17.705 25.585 24.5 19.4733 24.5 13.5542C24.5 9.38833 21.135 6 17 6ZM17 17.6667C14.7025 17.6667 12.8333 15.7975 12.8333 13.5C12.8333 11.2025 14.7025 9.33333 17 9.33333C19.2975 9.33333 21.1667 11.2025 21.1667 13.5C21.1667 15.7975 19.2975 17.6667 17 17.6667Z",
  fill: "white"
});

function SvgIconPinActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPinActive);
export default __webpack_public_path__ + "static/media/icon_pin_active.8abdbc05.svg";
export { ForwardRef as ReactComponent };